import { ExportGapFilterType } from "@app/exports/enumerations";
import { QESCheckbox, QESRadioButton, QESRadioGroup } from "@app/shared/qes-standards"
import { FC, useContext, useMemo, useEffect, useState } from "react";
import { VolumeReportsContext } from "./VolumeReportsContext";
import { Roles, UserContext } from "@app/user";

export const SummarySpecialtyVolumeReportsCountiesFilters: FC<React.PropsWithChildren<unknown>> = () => {
  const wizardContext = useContext(VolumeReportsContext);
  const userContext = useContext(UserContext);
  const [isCurrentServiceArea, setIsCurrentServiceArea] = useState<boolean>(false);
  const [isOpportunityServiceArea, setIsOpportunityServiceArea] = useState<boolean>(false);

  const currentServiceArea = "Current Service Area";
  const opportunityServiceArea = "Opportunities to Expand";

  const showFillableByMultiple = useMemo(() => {
    return userContext.roles.includes(Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER);
  }, [userContext.roles]);

  const isStateAggregateReport = wizardContext.reportType === "stateaggregate";

  useEffect(() => {
    setIsCurrentServiceArea(wizardContext.specialtySummaryServicingTypes.includes(currentServiceArea));
    setIsOpportunityServiceArea(wizardContext.specialtySummaryServicingTypes.includes(opportunityServiceArea));
  }, [wizardContext.specialtySummaryServicingTypes]);

  return (
    <section>
      <h2 className="header-m">Counties Filter</h2>
      <p>Please select the counties to include:</p>

      <p className="mt-4 mb-1">Include</p>
      <>
        <QESCheckbox
          label={currentServiceArea}
          testId={`volume-reports__counties-servicing-filters--${currentServiceArea.toLowerCase().replaceAll(" ", "-")}`}
          onChange={(e) => {
            e.target.checked ?
              wizardContext.setSpecialtySummaryServicingTypes([...wizardContext.specialtySummaryServicingTypes, currentServiceArea]) :
              wizardContext.setSpecialtySummaryServicingTypes(wizardContext.specialtySummaryServicingTypes.filter(x => x != currentServiceArea));
          }}
          checked={isCurrentServiceArea}
          name="counties-filter"
        />
        <QESCheckbox
          label={opportunityServiceArea}
          testId={`volume-reports__counties-servicing-filters--${opportunityServiceArea.toLowerCase().replaceAll(" ", "-")}`}
          onChange={(e) => {
            e.target.checked ?
              wizardContext.setSpecialtySummaryServicingTypes([...wizardContext.specialtySummaryServicingTypes, opportunityServiceArea]) :
              wizardContext.setSpecialtySummaryServicingTypes(wizardContext.specialtySummaryServicingTypes.filter(x => x != opportunityServiceArea));
          }}
          checked={isOpportunityServiceArea}
          name="counties-filter"
        />
      </>
      <p className="mt-4 mb-1">Include</p>
      <QESCheckbox
        label="Active Counties"
        testId="volume-reports__active-counties"
        checked={wizardContext.activeCounties && wizardContext.specialtySummaryServicingTypes.includes(currentServiceArea)}
        disabled={!isCurrentServiceArea}
        onChange={(e) => { wizardContext.setActiveCounties(e.target.checked) }}
      />
      <QESCheckbox
        label="Pending Counties"
        testId="volume-reports__pending-counties"
        checked={wizardContext.pendingCounties && wizardContext.specialtySummaryServicingTypes.includes(currentServiceArea)}
        disabled={!isCurrentServiceArea}
        onChange={(e) => { wizardContext.setPendingCounties(e.target.checked) }}
      />
      <QESCheckbox
        label="Approved Counties"
        testId="volume-reports__approved-counties"
        checked={wizardContext.approvedCounties && wizardContext.specialtySummaryServicingTypes.includes(currentServiceArea)}
        disabled={!isCurrentServiceArea}
        onChange={(e) => { wizardContext.setApprovedCounties(e.target.checked) }}
      />

      {!isStateAggregateReport &&
        <QESRadioGroup
          groupLabel="Include"
          groupContainerClass="mt-4"
        >
          <QESRadioButton
            label="All Counties"
            name="counties-gaps"
            testId="volume-reports__counties-gaps-filters--all"
            value={ExportGapFilterType.All}
            checked={wizardContext.countiesGapsFilter === ExportGapFilterType.All}
            onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
          />
          <QESRadioButton
            label="Counties with Gaps"
            name="counties-gaps"
            testId="volume-reports__counties-gaps-filters--gaps"
            value={ExportGapFilterType.Gaps}
            checked={wizardContext.countiesGapsFilter === ExportGapFilterType.Gaps}
            onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
          />
          <QESRadioButton
            label="Counties with Gaps Fillable by Single Provider"
            name="counties-gaps"
            testId="volume-reports__counties-gaps-filters--fillable-by-single-provider"
            value={ExportGapFilterType.FillableBySingleProvider}
            checked={wizardContext.countiesGapsFilter === ExportGapFilterType.FillableBySingleProvider}
            onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
          />
          <QESRadioButton
            label="Counties with Exceptions"
            name="counties-gaps"
            testId="volume-reports__counties-gaps-filters--exceptions"
            value={ExportGapFilterType.Exceptions}
            checked={wizardContext.countiesGapsFilter === ExportGapFilterType.Exceptions}
            onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
          />
          {showFillableByMultiple && (
            <QESRadioButton
              label="Counties with Fillable Gaps"
              name="counties-gaps"
              testId="volume-reports__counties-gaps-filters--fillable-gaps"
              value={ExportGapFilterType.FillableGaps}
              checked={wizardContext.countiesGapsFilter === ExportGapFilterType.FillableGaps}
              onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
            />
          )}
        </QESRadioGroup>
      }
    </section >
  );
}